import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ApiResponse} from '../classes/api-response';
import {environment} from '../../environments/environment';
import {map} from 'rxjs/operators';
import {Sim} from '../model/sim';
import {HttpClient} from '@angular/common/http';
import {Constants} from "../utils/constants";
import {UtilsService} from "./utils.service";
import {CreateSimDTO} from '../model/dto/sim/create-sim.dto';
import {AssignSimDTO} from '../model/dto/sim/assign-sim.dto';
import {UpdateSimDTO} from '../model/dto/sim/update-sim.dto';

@Injectable({
  providedIn: 'root'
})
export class SimsService {

  private readonly entities = Constants.entities;
  private readonly crtlPathFragment = this.entities.sims;
  private readonly crtlFullPath = `${environment.apiUrl}/${this.crtlPathFragment}`;

  constructor(private http: HttpClient) {
  }

  public getAllSims(statuses?: string[]): Observable<Sim[]> {
    const params = UtilsService.buildUrl(statuses);
    return this.http
      .get<ApiResponse>(`${this.crtlFullPath}`, { params })
      .pipe(map(value => value.data as Sim[]));
  }

  public getSim(id?: number, statuses?: string[]): Observable<Sim> {
    const params = UtilsService.buildUrl(statuses);
    return this.http
      .get<ApiResponse>(`${this.crtlFullPath}/${id}`, { params })
      .pipe(map(value => value.data as Sim));
  }

  public createSim(sim: CreateSimDTO): Observable<Sim> {
    return this.http
      .post<ApiResponse>(`${this.crtlFullPath}`, sim)
      .pipe(map(value => value.data as Sim));
  }

  public updateSim(id: number, sim: UpdateSimDTO): Observable<void> {
    return this.http
      .patch<ApiResponse>(`${this.crtlFullPath}/${id}`, sim)
      .pipe(map(() => { }));
  }

  public deleteSim(id: number): Observable<void> {
    return this.http
      .delete<ApiResponse>(`${this.crtlFullPath}/${id}`)
      .pipe(map(() => { }));
  }

  public associateSim(boxId?: number, sim?: AssignSimDTO): Observable<void> {
    return this.http
      .put<ApiResponse>(`${environment.apiUrl}/${this.entities.boxes}/${boxId}/${this.entities.sim}`, sim)
      .pipe(map(() => { }));
  }

  public deleteSimAssociation(boxId?: number): Observable<void> {
    return this.http
      .delete<ApiResponse>(`${environment.apiUrl}/${this.entities.boxes}/${boxId}/${this.entities.sim}`)
      .pipe(map(() => { }));
  }

}
